import { Box } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { customPalette } from '../../themes/customTheme';

export const Graphic = ({ data }) => {
  const translate = useTranslate();

  const formatTooltipLabel = label => `Día ${label}`;
  const formatTooltipValue = (value, name) => {
    let parts = name.split('_');
    let formattedValue =
      typeof value === 'number' && value % 1 !== 0 ? value.toFixed(2) : value;
    return [
      formattedValue + '%',
      translate(`resources.dashboard.list.card_graphic.fields.${parts[1]}`),
    ];
  };

  const toPercent = decimal => `${decimal}%`;

  return (
    <Box
      sx={{
        width: '100%',
        height: 'auto',
      }}
    >
      <ResponsiveContainer
        width="100%"
        height="100%"
        maxHeight="480px"
        minHeight="320px"
      >
        <LineChart
          width={500}
          height={400}
          data={data}
          margin={{
            top: 10,
            right: 30,
            left: 0,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={'date'} />
          <YAxis tickFormatter={toPercent} />
          <Tooltip
            labelFormatter={formatTooltipLabel}
            formatter={formatTooltipValue}
          />
          <Line
            type="monotone"
            dataKey="total_subscribers"
            stroke={customPalette.subscribers.main}
          />
          <Line
            type="monotone"
            dataKey="total_visits"
            stroke={customPalette.visits.main}
          />
          <Line
            type="monotone"
            dataKey="total_notes"
            stroke={customPalette.notes.main}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};
